import React from 'react'

const NoInternet = () => {
  return (
    <div>NoInternet</div>
  )
}

export default NoInternet